module.exports = __webpack_public_path__ + "static/media/vuejs-original.9cf6b38f.svg";